import { MenuItem } from '@mui/material';

import styled from 'styled-components';

// MenuItem is nowrap, which cuts a long record name off; the prototype's options wrap it.
export const StyledOption = styled(MenuItem)`
  white-space: normal;
`;
